var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 874,
    viewBox: "0 0 640 874",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1040.88 -58.709H-55.6992V1037.97H1040.88V-58.709Z",
    fill: "#054ADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.88 -58.6992L492.59 489.631H1040.88V-58.6992Z",
    fill: "#4B7DE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.88 489.631H492.59V1037.97H1040.88V489.631Z",
    fill: "#FFD166"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.591 1037.97L218.441 763.801V1037.97H492.591Z",
    fill: "#4B7DE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.88 489.631L492.59 1037.97H1040.88V489.631Z",
    fill: "#043387"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M492.66 215.451L766.81 -58.7188V215.451H492.66Z",
    fill: "#A8C0F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.441 763.802L492.591 489.592V1037.97L218.441 763.802Z",
    fill: "#A8C0F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M766.74 489.631H492.59C492.59 641.041 615.33 763.781 766.74 763.781V489.631Z",
    fill: "#BED0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.6992 763.732C95.7108 763.732 218.451 640.992 218.451 489.592H-55.6992V763.732Z",
    fill: "#A8C0F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M766.74 489.631V352.631C730.406 352.631 695.559 367.065 669.867 392.757C644.174 418.45 629.74 453.296 629.74 489.631H766.74Z",
    fill: "#A8C0F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M629.74 489.631C629.74 525.966 644.174 560.812 669.867 586.504C695.559 612.197 730.406 626.631 766.74 626.631V489.631H629.74Z",
    fill: "#FFD166"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.451 -58.709H-55.6992V489.631H218.451V-58.709Z",
    fill: "#043387"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M492.601 -58.709H218.451V489.631H492.601V-58.709Z",
    fill: "#4B7DE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.6992 215.441C95.7108 215.441 218.451 92.7008 218.451 -58.6992H-55.6992V215.441Z",
    fill: "#FFD166"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M492.592 -58.6992L218.422 215.461L218.442 -58.6992H492.592Z",
    fill: "#A8C0F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.6992 1037.97H218.441V763.801L-55.6992 1037.95V1037.97Z",
    fill: "#BED0F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.6992 1037.95L218.441 763.801H-55.6992V1037.95Z",
    fill: "#043387"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/loginBg.25f8639f15f97e34adf4552ed6be42c4.svg";
export { ForwardRef as ReactComponent };